// extracted by mini-css-extract-plugin
export default {"container":"CheckboxField_container__UQfQm","header":"CheckboxField_header__jplus"};